/* eslint-disable react/prop-types */
import { Typography } from 'components/DesignSystemV2/Typography';
import { LazyImage } from 'components/LazyImage';
import { HeadlineIcon } from 'components/HeadlineIcon';
import { graphql, Link, useStaticQuery } from 'gatsby';
import {
  groupBy,
  keys,
  map,
  merge,
  pick,
  reduce,
  values,
  flatMap
} from 'lodash';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import * as React from 'react';
import Popup from 'reactjs-popup';
import IconCheck from 'shared/CourseLanding/Detail/icons/IconCheck';
import { colorsV2 } from 'style/colors-v2';
import styled from 'styled-components';
import { Cell, Grid } from 'styled-css-grid';
import Flex from 'styled-flex-component';
import { useAllTeacherData } from '../DolTeachers/AllDolTeachers';
import { IconChervonRight } from './icons/IconChervonRight';
import { useCoursesGroupData } from './data/useCoursesGroupData';
import { useTeacherOnlineData } from './data/useTeacherOnlineData';
import { useOtherCourseData } from './data/useOtherCourseData';
import { withHomePageSection } from 'components/withHomePageSection';
import { fromScreen } from 'utils/media-query/responsive.util';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { ChevronLeft, ChevronRight } from '@dolstaff/shared/es/icons';
import cl from 'classnames';
import { FreeMode, Navigation } from 'swiper';
import { getUniqueTeachers } from 'shared/DolTeachers/AllDolTeachers';
import { AspectRatio } from 'components/AspectRatio/AspectRatio';

const routeLink = item => {
  if (item.classGroup.includes('TOEIC')) {
    return '/toeic';
  }
  if (item.classGroup.includes('SAT')) {
    return '/sat';
  }
  if (item.classGroup.includes('Tiếng Anh')) {
    return '/tieng-anh-giao-tiep';
  }
  return item.linkLevel;
};

const ROUTE_COURSE = {
  'Khóa IELTS cơ bản': '/ielts-co-ban',
  'Khóa IELTS nâng cao': '/ielts-nang-cao',
  'Khóa IELTS cấp tốc': '/ielts-cap-toc',
  'Khóa học khác': '/khoa-hoc-khac'
};
const NAVIGATION_BUTTON_SIZE = 40;

const TeacherImg = styled(LazyImage)`
  img {
    object-fit: cover;
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    position: absolute;
    border-radius: 8px;
  }
`;

export const CourseListContainer = styled.div`
  .course-list {
    .course-row {
      margin: 32px 0;
      ${fromScreen(776)} {
        marin: 52px 0;
        .swiper {
          position: relative;
          &:after {
            position: absolute;
            z-index: 4;
            content: '';
            right: -1px;
            top: 0;
            height: 100%;
            width: 113px;
            background: linear-gradient(
              270deg,
              #ffffff 0%,
              rgba(255, 255, 255, 0) 100%
            );
          }
          &.end-slider {
            &:after {
              display: none;
            }
          }
        }
      }
      ${fromScreen(1144)} {
        margin: 100px 0;
        .swiper {
          &:after {
            display: none;
          }
        }
      }
    }
  }

  .course-group-list {
    margin-top: 24px;
    position: relative;

    .swiper-slide {
      width: fit-content !important;
      height: auto;
    }

    .navigation-action {
      display: none;
      color: ${colorsV2.black100};
      cursor: pointer;
      position: absolute;
      min-width: ${NAVIGATION_BUTTON_SIZE}px;
      min-height: ${NAVIGATION_BUTTON_SIZE}px;
      max-width: ${NAVIGATION_BUTTON_SIZE}px;
      max-height: ${NAVIGATION_BUTTON_SIZE}px;
      filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.32));
      place-items: center;
      border-radius: 50%;
      background-color: ${colorsV2.white100};
      font-size: 28px;
      line-height: 0;
      z-index: 2;

      ${fromScreen(776)} {
        display: grid;
        top: 20%;
      }

      &.next {
        right: -${NAVIGATION_BUTTON_SIZE / 2}px;
      }
      &.prev {
        left: -${NAVIGATION_BUTTON_SIZE / 2}px;
      }
      &.disabled {
        display: none;
      }
    }

    .card-course {
      width: 252px;
      position: relative;
      .rating {
        position: absolute;
        top: 8px;
        right: 8px;
        background: ${colorsV2.yellow10};
        display: flex;
        align-items: center;
        padding: 0 4px;
        border-radius: 4px;
      }

      color: ${colorsV2.black100};

      .card-course-image {
        margin-bottom: 12px;

        img {
          border-radius: 8px;
        }
      }

      .card-course-title {
        margin-bottom: 4px;
        a {
          color: ${colorsV2.black100};

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .card-course-description {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 12px;
      }

      .card-course-body {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: ${colorsV2.black80};
        .teacher-name {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
  }
`;

export const CardCourse = ({ data, moreInfo = true }) => {
  const {
    name,
    description,
    teacher,
    numberOfLevels,
    fromLevelToLevel,
    numberOfLectures,
    theoryDurationInMinutes,
    practiceDurationInMinutes,
    updatedAt,
    classGroup
  } = data;
  const statisticText = [
    numberOfLevels ? `${numberOfLevels} levels` : undefined,
    fromLevelToLevel,
    numberOfLectures ? `${numberOfLectures} lectures` : undefined,
    theoryDurationInMinutes
      ? `${minsToHours(theoryDurationInMinutes)} theory`
      : undefined,
    theoryDurationInMinutes
      ? `${minsToHours(practiceDurationInMinutes)} practice`
      : undefined
  ]
    .filter(Boolean)
    .join(' • ');

  return (
    <div className="card-course">
      <div className="card-course-image">
        <Link to={routeLink(data)}>
          <AspectRatio>
            <TeacherImg alt={name} handle={teacher?.listingImageHandler} />
          </AspectRatio>
        </Link>
      </div>
      <div className="card-course-title">
        <Link to={routeLink(data)}>
          <Typography variant="semi-bold/20-28" as="h3">
            {classGroup.includes('IELTS')
              ? getName(name)
              : getNameOtherCourse(classGroup)}
          </Typography>
        </Link>
      </div>
      <div className="card-course-description">{description}</div>
      <div className="card-course-body">
        <div className="teacher-name">Giáo viên: {teacher?.displayName}</div>
        {moreInfo && (
          <>
            <div className="course-info">{statisticText}</div>
            {updatedAt && (
              <div className="updated-time">
                <Typography
                  variant="regular/14"
                  style={{
                    color: updatedAt.includes('Chỉ mở trong dịp hè')
                      ? colorsV2.primary100
                      : colorsV2.green100
                  }}
                >
                  {updatedAt}
                </Typography>
              </div>
            )}
          </>
        )}
      </div>
      <Typography
        variant="semi-bold/12-20"
        style={{ color: colorsV2.yellow100 }}
        className="rating"
      >
        <LazyImage handle="1rv5msRHQpihJx9ujCrU" alt="rating" />
        {((teacher?.feedbackScore || 0) / 2).toFixed(1)}
      </Typography>
    </div>
  );
};

export const CardCoursePopup = ({ courseItem, moreInfo = true }) => {
  return (
    <Popup
      contentStyle={{ width: 316 }}
      on={['hover']}
      mouseEnterDelay={500}
      position={['right center', 'left center']}
      trigger={
        <div>
          <CardCourse
            key={courseItem.name + courseItem.description}
            data={courseItem}
            moreInfo={moreInfo}
          />
        </div>
      }
    >
      <PopupContent>
        <Typography variant="semi-bold/20">{courseItem.name}</Typography>
        <Grid columns="max-content 1fr" style={{ width: 285, marginTop: 16 }}>
          {courseItem.whatYouGets.map(benefit => (
            <>
              <Cell middle>
                <IconCheck />
              </Cell>
              <Cell middle>
                <Typography variant="regular/14">{benefit}</Typography>
              </Cell>
            </>
          ))}
        </Grid>

        <Flex rowReverse style={{ marginTop: 16 }}>
          <CourseLink href={routeLink(courseItem)} target="_blank">
            <Typography
              variant="semi-bold/14"
              style={{ color: colorsV2.white100 }}
            >
              Tìm hiểu thêm
            </Typography>
            <IconChervonRight style={{ color: colorsV2.white100 }} />
          </CourseLink>
        </Flex>
      </PopupContent>
    </Popup>
  );
};
const prefix = 'course-card';

const groupCoursesForDisplay = (courses, groupCourses) =>
  groupCourses.map(courseGroupMapping => {
    const coursesOfGroup = courseGroupMapping.levels.map(courseInfo => {
      return courses.find(course => courseInfo === course.level);
    });
    return {
      name: courseGroupMapping.name,
      courses: coursesOfGroup
    };
  });

const Courses = ({ courses }) => {
  const { desktopGroupCourses } = useCoursesGroupData();
  return (
    <CoursesLayout
      courses={courses}
      groupCourses={desktopGroupCourses}
      CourseDisplay={SliderCources}
    />
  );
};

export const SliderCources = ({ courses }) => {
  const [reachEndSlider, setReachEndSlider] = React.useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false
  });
  const levelOnline = useTeacherOnlineData();
  const { getTeacherOfLevel } = useAllTeacherData();
  const otherCourseName = useOtherCourseData();
  const teachers = getUniqueTeachers(
    flatMap(levelOnline.map(levelName => getTeacherOfLevel(levelName)))
  );
  const teacherName = teachers.map(item => item.displayName);
  const otherCourse = courses
    .filter(item => !item.name.includes('IELTS'))
    .map(elm => elm.courses)
    .flat();
  const otherCourseList = otherCourseName.map(item => {
    const index = otherCourse.findIndex(course => course.level === item.level);
    if (index > -1) {
      return otherCourse[index];
    }
    return item;
  });
  const ieltsCourseOnly = courses.filter(item => item.name.includes('IELTS'));
  const courseOnline = [
    {
      classGroup: 'IELTS Online',
      classGroupHomepageOrder: null,
      description: 'Học IELTS Online - xịn như Offline - Đảm Bảo Đầu Ra',
      id: undefined,
      isBestSeller: false,
      level: 'PRONUN',
      linkLevel: '/hoc-ielts-online',
      name: 'IELTS Online',
      numberOfLectures: '27',
      order: 11,
      practiceDurationInMinutes: 3260,
      ratedUsers: '102',
      starsInFloat: 4.925,
      teacher: {
        displayName: teacherName.toString(),
        listingImageHandler: teachers[0].listingImageHandler,
        feedbackScore: 9.5
      },
      theoryDurationInMinutes: 3260,
      updatedAt: 'Updated in December 2020'
    }
  ];

  const listCourse = [
    ...ieltsCourseOnly,
    { name: 'IELTS Online', courses: courseOnline },
    { name: 'Khóa học khác', courses: otherCourseList }
  ];

  return (
    <CourseListContainer>
      <div className="course-list">
        {listCourse &&
          listCourse.map((value, key) => (
            <div key={key} className="course-row">
              <HeadlineIcon url={ROUTE_COURSE[value.name]} viewDetail>
                <Typography
                  variant="bold/24-32"
                  tabletVariant="bold/32-40"
                  desktopVariant="bold/40-48"
                  v3
                  as="h2"
                >
                  {getName(value.name)}
                </Typography>
              </HeadlineIcon>
              <TabCourcesIntro name={value.name} />
              <div className="course-group-list">
                <>
                  <div
                    className={cl(
                      'navigation-action',
                      `${prefix + key}`,
                      'next'
                    )}
                  >
                    <ChevronRight />
                  </div>
                  <div
                    className={cl(
                      'navigation-action',
                      `${prefix + key}`,
                      'prev'
                    )}
                  >
                    <ChevronLeft />
                  </div>
                </>
                <Swiper
                  pagination={{
                    clickable: true
                  }}
                  navigation={{
                    nextEl: `${prefix ? `.${prefix + key}` : ''}.next`,
                    prevEl: `${prefix ? `.${prefix + key}` : ''}.prev`,
                    disabledClass: 'disabled'
                  }}
                  modules={[Navigation, FreeMode]}
                  spaceBetween={24}
                  freeMode={{
                    enabled: true,
                    minimumVelocity: 0.05,
                    momentum: true
                  }}
                  className={cl({ 'end-slider': reachEndSlider[key] })}
                  slidesPerView="auto"
                  slidesPerGroup={2}
                  onReachEnd={() => {
                    setReachEndSlider({
                      ...reachEndSlider,
                      [key]: true
                    });
                  }}
                >
                  {value?.courses.map(item => (
                    <SwiperSlide key={item.name + item.description}>
                      {item.whatYouGets?.length ? (
                        <CardCoursePopup
                          key={item.name + item.description}
                          courseItem={item}
                        />
                      ) : (
                        <CardCourse
                          key={item.name + item.description}
                          data={item}
                        />
                      )}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          ))}
      </div>
    </CourseListContainer>
  );
};

/* DESKTOP */
const TabCourcesIntro = ({ name }) => {
  const $name = name.toLowerCase().trim();
  switch ($name) {
    case 'khóa ielts cấp tốc':
      return (
        <TabCourcesIntroContainer>
          <Typography variant="regular/20">
            Với chương trình học tinh gọn, phương pháp Linearthinking tư duy
            thông minh, sự tận tâm theo sát của giáo viên và chính sách đảm bảo
            đầu ra, bạn sẽ tăng được 1.5 band IELTS sau 2 tháng kèm xây được nền
            Tiếng Anh & tư duy ngôn ngữ vững chắc.
          </Typography>
        </TabCourcesIntroContainer>
      );

    case 'khóa ielts cơ bản':
      return (
        <TabCourcesIntroContainer>
          <Typography variant="regular/20">
            Nắm chắc tư duy đọc, viết, nói 1 câu tiến đến đọc, viết, nói thành
            thạo 1 đoạn. Quan trọng nhất ở giai đoạn này là mình cần xây nền
            chắc chắn, học bản chất để bài thi IELTS hay TOEIC hay bất cứ bài
            thi Tiếng Anh nào cũng như nhau cả.
          </Typography>
        </TabCourcesIntroContainer>
      );

    case 'khóa ielts nâng cao':
      return (
        <TabCourcesIntroContainer>
          <Typography variant="regular/20">
            Nhiều bạn bị chững lại ở giai đoạn này, làm hoài không tăng điểm.
            Cái cần nhất lúc này là Tư Duy để tận dụng tối đa kiến thức sẵn có
            và bứt phá đạt điểm mong muốn. Hay nói vắn tắt “Học Tư duy chấp hết
            đề, tư duy ít Vocab đọc vẫn hiểu” của Linearthinking.
          </Typography>
        </TabCourcesIntroContainer>
      );
  }
  return null;
};

const TabCourcesIntroContainer = styled.div`
  display: grid;
  gap: 24px;
  margin-top: 16px;
  strong {
    margin: 0 5px;
    color: ${colorsV2.primary100};
  }
  display: none;
  ${fromScreen(1144)} {
    display: block;
  }
`;

export const getName = name => {
  const hasPrefix = name.startsWith('Khóa');
  const isIeltsCourse = name.includes('IELTS');

  if (hasPrefix && isIeltsCourse) {
    return name.substr(5).trim();
  }

  return name;
};

const getNameOtherCourse = name => {
  const hasPrefix = name.startsWith('Khóa');

  if (hasPrefix) {
    return name.substr(5).trim();
  }

  return name;
};

export const CoursesLayout = ({
  courses,
  groupCourses,
  CourseDisplay,
  extraProps = {}
}) => {
  const sortedCourses = groupCoursesForDisplay(courses, groupCourses);
  return (
    <CourseDisplay
      courses={sortedCourses}
      groupCourses={groupCourses}
      {...extraProps}
    />
  );
};

const CourseLink = styled.a`
  background: ${colorsV2.primary100};
  border-radius: 8px;
  padding: 8px 16px;
  border: none;
  outline: none;
  display: inline-flex;
  text-decoration: none;
  align-items: center;

  * {
    color: ${colorsV2.white100};
  }

  svg {
    margin-left: 10px;
  }
`;

const PopupContent = styled.div`
  padding: 16px;
`;

const TeacherType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  imgHandle: PropTypes.string
});

const IncludesType = PropTypes.shape({
  linearthinking: PropTypes.bool,
  free: PropTypes.number,
  weeks: PropTypes.number,
  sessions: PropTypes.number,
  hours: PropTypes.number,
  promotion: PropTypes.string
});

const CourseType = PropTypes.shape({
  id: PropTypes.string,
  order: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  teacher: TeacherType,
  numberOfLectures: PropTypes.number,
  theoryDurationInMinutes: PropTypes.number,
  practiceDurationInMinutes: PropTypes.number,
  updatedAt: PropTypes.string,
  starsInFloat: PropTypes.number,
  ratedUsers: PropTypes.number,
  includes: IncludesType
});

Courses.propTypes = {
  courses: PropTypes.arrayOf(CourseType)
};

const ungroupData = groupedData => {
  return reduce(
    map(groupedData.group, groupItem => {
      return {
        item: groupItem.edges[0].node,
        fieldValue: groupItem.fieldValue
      };
    }),
    (merged, item) => {
      return { ...merged, [item.fieldValue]: item.item };
    },
    {}
  );
};

const listDataFromGrouped = groupedData => {
  return reduce(
    map(groupedData.group, groupItem => {
      return {
        items: groupItem.edges.map(edge => edge.node),
        fieldValue: groupItem.fieldValue
      };
    }),
    (merged, item) => {
      return { ...merged, [item.fieldValue]: item.items };
    },
    {}
  );
};

const calculateLearningDuration = sylabus => {
  return reduce(
    sylabus,
    (sum, item) => (sum += Number(item.durationInMinutes)),
    0
  );
};

const toLearningStatistic = syllabusByLevel => {
  const learningStatistics = map(values(syllabusByLevel), syllabuses => {
    const syllabusByType = groupBy(syllabuses, 'syllabusType');
    return {
      level: syllabuses[0].level,
      theoryDurationInMinutes: calculateLearningDuration(syllabusByType.theory),
      practiceDurationInMinutes: calculateLearningDuration(
        syllabusByType.practice
      )
    };
  });
  return reduce(
    learningStatistics,
    (merged, statistic) => {
      return { ...merged, [statistic.level]: { ...statistic } };
    },
    {}
  );
};

const mapToCourseOnlineFrom = ({ data }) => {
  const {
    onlineLevelData,
    allGoogleSpreadsheetDolLandingPageRatingByLevel,
    onlineCourseDefaultInfo
  } = data;
  const defaultInfo = onlineCourseDefaultInfo.jsonContanier.content;
  const level = onlineLevelData.group[0].edges[0].node;
  const rating = get(
    allGoogleSpreadsheetDolLandingPageRatingByLevel.group.find(
      item => get(item, 'fieldValue', '').toLowerCase() === '4.0'
    ),
    'edges[0].node',
    { average: 0, count: 0 }
  );

  return {
    ...defaultInfo,
    teacher: {
      ...defaultInfo.teacher,
      displayName: defaultInfo.teacher.name,
      listingImageHandler: defaultInfo.teacher.imgHandle
    },
    isBestSeller: level.levelBestseller,
    updatedAt: level.levelUpdated,

    // Learning statistic
    numberOfLevels: onlineLevelData.group.length,
    // Rating
    starsInFloat: rating.average ? rating.average / 2 : 0,
    ratedUsers: rating.count ? rating.count : 0
  };
};

const whatYouGetKeys = Array.from(
  { length: 8 },
  (_, index) => `whatYouGet${index + 1}`
);

const mapToCourseFrom = ({ data, teachers }) => {
  const {
    allGoogleSpreadsheetDolLandingPageMarLevelData,
    allGoogleSpreadsheetDolLandingPageAcaSyllabusByLevel,
    allGoogleSpreadsheetDolLandingPageRatingByLevel
  } = data;

  const levels = ungroupData(allGoogleSpreadsheetDolLandingPageMarLevelData);
  const allLevels = keys(levels);
  const levelLearningInfo = pick(
    ungroupData(allGoogleSpreadsheetDolLandingPageAcaSyllabusByLevel),
    allLevels
  );
  const levelLearningStatistic = pick(
    toLearningStatistic(
      listDataFromGrouped(allGoogleSpreadsheetDolLandingPageAcaSyllabusByLevel)
    ),
    allLevels
  );
  const levelRating = pick(
    ungroupData(allGoogleSpreadsheetDolLandingPageRatingByLevel),
    allLevels
  );
  const levelInfo = merge(
    merge(merge(levels, levelLearningInfo), levelRating),
    levelLearningStatistic
  );

  return map(values(levelInfo), level => {
    const teacher = teachers.find(item => item.name === level.teacherRw);
    const whatYouGets = whatYouGetKeys.map(key => level[key]).filter(i => i);
    return {
      id: level.name,
      order: level.order,
      classGroupHomepageOrder: level.classGroupHomepageOrder,
      name: level.levelDisplay,
      linkLevel: level.slug,
      level: level.level,
      description: level.levelDescription,
      teacher,
      isBestSeller: level.levelBestseller === 'TRUE',
      updatedAt: level.levelUpdated,
      // Learning statistic
      numberOfLectures: level.totalSessions,
      theoryDurationInMinutes: level.theoryDurationInMinutes,
      practiceDurationInMinutes: level.practiceDurationInMinutes,
      classGroup: level.classGroup,
      // Rating
      starsInFloat: level.average ? level.average / 2 : 0,
      ratedUsers: level.count ? level.count : 0,
      // Includes
      includes: {
        linearthinking: true,
        free: 4,
        weeks: level.totalWeeks,
        sessions: level.totalSessions,
        hours: level.totalHours,
        promotion: 'Tặng app & sách giáo trình'
      },
      whatYouGets
    };
  });
};

export const useCoursesWithTeacher = () => {
  const data = useStaticQuery(graphql`
    {
      onlineLevelData: allGoogleSpreadsheetDolLandingPageMarLevelData(
        filter: { classGroup: { eq: "IELTS Online" } }
      ) {
        group(field: level) {
          edges {
            node {
              level
              levelDescription
              levelDisplay
              teacherRw
              levelBestseller
              levelUpdated
              classGroupScheduleOrder
              classGroupHomepageOrder
              order
            }
          }
          fieldValue
        }
      }
      allGoogleSpreadsheetDolLandingPageMarLevelData(
        filter: { classGroup: { ne: "IELTS Online" } }
      ) {
        group(field: level) {
          edges {
            node {
              level
              classGroup
              slug
              levelDescription
              levelDisplay
              teacherRw
              levelBestseller
              levelUpdated
              classGroupScheduleOrder
              classGroupHomepageOrder
              order
              whatYouGet1
              whatYouGet2
              whatYouGet3
              whatYouGet4
              whatYouGet5
              whatYouGet6
              whatYouGet7
              whatYouGet8
            }
          }
          fieldValue
        }
      }
      allGoogleSpreadsheetDolLandingPageAcaSyllabusByLevel {
        group(field: level) {
          edges {
            node {
              level
              syllabusType
              totalHours
              totalSessions
              totalWeeks
              durationInMinutes
            }
          }
          fieldValue
        }
      }

      allGoogleSpreadsheetDolLandingPageRatingByLevel {
        group(field: level) {
          edges {
            node {
              level
              count
              average
            }
          }
          fieldValue
        }
      }
      onlineCourseDefaultInfo: gcms {
        jsonContanier(where: { name: "Landing_Course_CourseList_Online" }) {
          content
        }
      }
    }
  `);

  const { teachers } = useAllTeacherData();

  const courseWithTeachers = mapToCourseFrom({
    data,
    teachers
  });

  const courseOnlineWithTeachers = mapToCourseOnlineFrom({ data, teachers });

  return { courseWithTeachers, courseOnlineWithTeachers };
};

export const GCMSCourses = withHomePageSection(() => {
  const { courseWithTeachers, courseOnlineWithTeachers } =
    useCoursesWithTeacher();
  return (
    <Courses
      courses={courseWithTeachers}
      courseOnline={courseOnlineWithTeachers}
    />
  );
}, {});

export function minsToHours(mins) {
  if (mins <= 0) return `0 mins`;

  const remainMins = mins % 60;
  const hours = (mins - remainMins) / 60;

  const hoursInString = hours > 0 ? `${hours}h` : '';
  const minsInString = mins > 0 ? `${remainMins}m` : '';

  return `${hoursInString} ${minsInString}`.trim();
}
